module.exports = __webpack_public_path__ + "img/emoticon-csat-5-on.576c662a.svg";